type Nullable<T> = T | null;

export type AUTHDataType = {
  code: Nullable<string>;
  error: Nullable<string>;
  error_description: Nullable<string>;
};

export enum GrantStateType {
  granted = "Granted",
  invalid = "Invalid Credentials",
}

type ChannelConfig = {
  name?: string;
  description?: string;
  adminAccountName: string;
  adminAccountToken: string;
  accountName?: string;
  accountToken?: string;
  sendTestMessage?: boolean;
};

export type ConfigEXO = ChannelConfig & {
  sender?: string;
  recipients?: string[];
};

export type ConfigTeams = ChannelConfig & {
  team?: string;
  channel?: string;
  mentionTeam?: boolean;
  mentionChannel?: boolean;
};

export type SmtpChannelConfig = {
  name: string;
  description?: string;
  accountName: string;
  accountPassword: string;
  server: string;
  port: string;
  timeout: number;
  useSSL: boolean;
  sender: string;
  recipients: string[];
  sendTestMessage: boolean;
};
